import PacmanLoader from "react-spinners/PacmanLoader";

export const Loader = () => {
  return (
    <div className="loader">
      <PacmanLoader />
    </div>
  );
};
